import { Injectable } from '@angular/core';

//A booking the AI-Assistant has prepared, for Make a Booking to fill in. The assistant never makes
//the booking itself: staff press Confirm on its card, Make a Booking opens with each step filled in
//from this, and staff step through it and take payment as they would for any booking - so the
//price, deposit and everything else come from Make a Booking's own code.
export interface bookingprefill {
  packageId: string;
  packageName: string;
  //The venue's wall clock: YYYY-MM-DD and HH:mm.
  date: string;
  time: string;
  //People on each of the package's admissions, by admissionid.
  admissions: { admissionid: string, count: number }[];
  //Extras from the package's own list, by extraid.
  extras: { extraid: string, qty: number }[];
  //An existing customer (customerid set), found for staff to pick - or a new one's details, filled
  //into the form for staff to finish.
  customer: {
    customerid?: string,
    firstName: string,
    lastName: string,
    email?: string,
    mobile?: string,
    address1?: string,
    address2?: string,
    townCity?: string,
    postCode?: string
  };
  notes: string;
}

//Hands the prepared booking from the assistant to Make a Booking. Held here rather than in the URL
//because it carries customer details. Taken once: Make a Booking takes it when it opens, so a later
//visit to Make a Booking starts empty as usual.
@Injectable({
  providedIn: 'root'
})
export class BookingPrefillService {

  private pending: bookingprefill = null;

  set(prefill: bookingprefill): void {
    this.pending = prefill;
  }

  take(): bookingprefill {
    const prefill = this.pending;
    this.pending = null;
    return prefill;
  }
}
